import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import TextField from "@material-ui/core/TextField";
import { API_DOCUMENTS_PATH } from "../../../../_emywork/helpers/UIHelper";
import Dropzone from "react-dropzone";
import { useIntl } from "react-intl";
import { AESVG } from "../../../../_emywork/components/svg";
import { AEButton } from "../../../../_emywork/components/buttons";
import { AELabel } from "../../../../_emywork/components/AELabel";
import { toAbsoluteUploadUrl, toEntityFileNameUrl } from "../../../_helpers";

const getFieldCSSClasses = (touched, errors) => {
  const classes = [];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function AEFile({
  field: { name, value }, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "select",
  validation = true,
  shrinkLabel = false,

  //dz props
  preview = false, //currently only work for images
  multiple = false,
  accept,
  ...props
}) {
  const { formatMessage } = useIntl();
  label = formatMessage({ id: label });
  customFeedbackLabel = customFeedbackLabel
    ? customFeedbackLabel
    : formatMessage({ id: "DROPZONE.DESCRIPTION" });
  // let InputLabelProps =  {}
  // if(shrinkLabel) InputLabelProps.shrink = true;
  // console.log(value)

  const Option = ({ file, index }) => {
    const file_name = file instanceof File ? file.name : file;

    return (
      <AELabel className="align-items-center">
        {file_name}
        <AESVG
          path={"/Navigation/Close.svg"}
          variant={"danger"}
          className={"pl-2"}
          size={"sm"}
          onClick={(e) => {
            e.stopPropagation();
            if (multiple) {
              let newValues = [...value];
              newValues.splice(index, 1);
              setFieldValue(name, newValues); // todo cancel pop up
            } else {
              setFieldValue(name, null);
            }
          }}
        />
      </AELabel>
    );
  };

  return (
    <>
      <Dropzone
        onDrop={(acceptedFiles) => {
          if (multiple) {
            setFieldValue(name, acceptedFiles);
          } else {
            setFieldValue(name, acceptedFiles[0]);
          }
        }}
        accept={accept}
        multiple={multiple}
        // noClick={true}
        noKeyboard={true}
      >
        {({ getRootProps, getInputProps, isDragActive }) => {
          let url = ``;
          if (preview && value) {
            switch (true) {
              case value instanceof File:
                url = URL.createObjectURL(value);
                break;
              default:
                url = toAbsoluteUploadUrl(`/users/${values.id}/${value}`);
                break;
            }

            // if(value instanceof File) {
            //
            // } else {
            //   if(values.file_name) {
            //     url = `${API_DOCUMENTS_PATH}/${values.id}/${values.file_name}`;
            //   }
            // }
          }

          return (
            <div
              {...getRootProps({
                className: "dropzone dropzone-default dropzone-brand h-100",
              })}
            >
              <input {...getInputProps()} />
              <div className="">
                {preview /* && (value || values.file_name) */ && url && (
                  <div className="symbol symbol-80">
                    <img src={url} className="rounded" alt={"..."} />
                    <span className={"symbol-badge top-1 right-0 "}>
                      <AESVG
                        path={"/Navigation/Close.svg"}
                        variant={"primary"}
                        className={"bg-light-primary rounded"}
                        // size={'md'}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (multiple) {
                            let newValues = [...value];
                            // newValues.splice(index,1)
                            setFieldValue(name, newValues); // todo cancel pop up
                          } else {
                            setFieldValue(name, null);
                          }
                        }}
                      />
                    </span>
                  </div>
                )}

                <div className={"col-12"}>
                  {isDragActive ? (
                    <p className="dropzone-msg-title">
                      {formatMessage({ id: "DROPZONE.DESCRIPTION" })}
                    </p>
                  ) : (
                    <h5 className="kt-section__title">
                      {label}
                      <br />

                      <small>
                        {withFeedbackLabel && (
                          <FieldFeedbackLabel
                            error={errors[name]}
                            touched={touched[name]}
                            label={label}
                            type={type}
                            customFeedbackLabel={customFeedbackLabel}
                          />
                        )}
                      </small>
                    </h5>
                  )}

                  {!preview &&
                    value &&
                    (multiple ? (
                      value.map((file, index) => (
                        <Option key={index} file={file} index={index} />
                      ))
                    ) : (
                      <Option file={value} />
                    ))}
                </div>
              </div>
            </div>
          );
        }}
      </Dropzone>

      {/*{label && <label>Enter {label}</label>}*/}
      {/*<TextField*/}
      {/*  type={type}*/}
      {/*  className={"form-control h-auto "+(validation && getFieldCSSClasses(touched[field.name], errors[field.name]))}*/}
      {/*  variant={"outlined"}*/}
      {/*  InputLabelProps={InputLabelProps}*/}
      {/*  size={"small"}*/}
      {/*  fullWidth*/}
      {/*  label={label}*/}
      {/*  {...field}*/}
      {/*  {...props}*/}
      {/*/>*/}
    </>
  );
}
